import { Intent, Tag } from '@blueprintjs/core'
import { sentenceCase } from 'change-case'
import * as React from 'react'

interface Props {
  status: string
}

export const PickedAndPackedStatusPill: React.FC<Props> = ({ status }) => {
  let prettyStatus = status

  let intent = null
  switch (status) {
    case 'PACKED':
      intent = Intent.SUCCESS
      break
    case 'PICKED':
      intent = Intent.PRIMARY
      break
    case 'EXCLUDED_FROM_PACKING':
      prettyStatus = 'REMOVED' // "removed" is how we label this on the packing screen
      intent = Intent.WARNING // We show DANGER on the packing screen, but on the order#show page, it's not really actionable, so make this a warning
      break
    case 'NOT_FOUND':
      intent = Intent.DANGER
      break
    case 'SKIPPED': // not really important to distinguish between "skipped" and "not picked" for this page
    default:
      prettyStatus = 'NOT PICKED'
      break
  }

  prettyStatus = sentenceCase(prettyStatus)

  return (
    <Tag round minimal intent={intent}>
      {prettyStatus}
    </Tag>
  )
}
